import { type AuthCtaMode } from "~/feature/auth/type";

export const AUTH_MESSAGE_TYPE = "ph:open-auth";

const isAuthCtaMode = (value: unknown): value is AuthCtaMode =>
  value === "sign-up" || value === "sign-in";

export const parseAuthMessage = (data: unknown): AuthCtaMode | null => {
  if (typeof data !== "object" || data === null) {
    return null;
  }

  const { type, mode } = data as { type?: unknown; mode?: unknown };
  if (type !== AUTH_MESSAGE_TYPE || !isAuthCtaMode(mode)) {
    return null;
  }

  return mode;
};
